/**
 * Internal dependencies
 */
import USER_ACTION from '@naruto/bgdapp/src/reducers/cores/user/events';
import {
  SetUserContentInitialAction,
  SetUserInitialApplicationAction,
  SetUserLoginStateAction,
  SetUserAuthStateAction,
  SetUserOAuthProcessStateAction,
  SetUserTokenInfoAction,
  SetUserSignInOAuthAction,
  SetUserSignOutOAuthAction,
  SetUserPermissionAction,
  SetUserRoleListAction,
  UserTokenInfo,
  UserSignInOAuthUrl,
  UserSignOutOAuthUrl,
  UserPermissionList,
  UserDepartRoleList
} from './types';

/* Initial */
export const SET_USER_INITIALIZE = (): SetUserContentInitialAction => ({
  type: USER_ACTION.SET_USER_INITIALIZE
});
export const SET_USER_INITIALIZE_APPLICATION = (): SetUserInitialApplicationAction => ({
  type: USER_ACTION.SET_USER_INITIALIZE_APPLICATION
});

/* User */
export const SET_USER_LOGIN_STATE = ({ isLogin }: { isLogin: boolean }): SetUserLoginStateAction => ({
  type: USER_ACTION.SET_USER_LOGIN_STATE,
  isLogin
});
export const SET_USER_AUTH_STATE = ({ isAuth }: { isAuth: boolean }): SetUserAuthStateAction => ({
  type: USER_ACTION.SET_USER_AUTH_STATE,
  isAuth
});
export const SET_USER_OAUTH_PROCESS_STATE = ({
  isSuccess
}: {
  isSuccess: boolean;
}): SetUserOAuthProcessStateAction => ({
  type: USER_ACTION.SET_USER_OAUTH_PROCESS_STATE,
  isSuccess
});
export const SET_USER_TOKEN_INFO = ({ info }: { info: UserTokenInfo }): SetUserTokenInfoAction => ({
  type: USER_ACTION.SET_USER_TOKEN_INFO,
  info
});
export const SET_USER_SIGN_IN_OAUTH_URL = ({ url }: { url: UserSignInOAuthUrl }): SetUserSignInOAuthAction => ({
  type: USER_ACTION.SET_USER_SIGN_IN_OAUTH_URL,
  url
});
export const SET_USER_SIGN_OUT_OAUTH_URL = ({ url }: { url: UserSignOutOAuthUrl }): SetUserSignOutOAuthAction => ({
  type: USER_ACTION.SET_USER_SIGN_OUT_OAUTH_URL,
  url
});
export const SET_USER_PERMISSION_LIST = ({
  permissions
}: {
  permissions: UserPermissionList;
}): SetUserPermissionAction => ({
  type: USER_ACTION.SET_USER_PERMISSION_LIST,
  permissions
});
export const SET_USER_ROLE_LIST = ({ roles }: { roles: UserDepartRoleList }): SetUserRoleListAction => ({
  type: USER_ACTION.SET_USER_ROLE_LIST,
  roles
});
